"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DatePicker;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _xDatePickers = require("@mui/x-date-pickers");
var _luxon = _interopRequireDefault(require("@date-io/luxon"));
var _luxon2 = require("luxon");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
require("./styles.scss");
var _date = require("../../utils/date");
/**
 * TODO: remove support for JS Date in DatePickerDateType once
 * clients have moved to only using DateTime objects in input props
 * and callback arguments.
 * export type DatePickerDateType = Exclude<DateType, Date> | null;
 */

const initializeDate = (value, timeZoneId) => {
  if (!value) {
    return null;
  }
  const date = (0, _date.getDate)(value, timeZoneId);
  return date !== null && date !== void 0 && date.isValid ? date : null;
};
function DatePicker(props) {
  var _props$locale;
  const [temporalValue, setTemporalValue] = (0, _react.useState)(initializeDate(props.value, props.defaultTimeZone));
  const [minDateTime, setMinDateTime] = (0, _react.useState)(initializeDate(props.minDate, props.defaultTimeZone));
  const [maxDateTime, setMaxDateTime] = (0, _react.useState)(initializeDate(props.maxDate, props.defaultTimeZone));
  const locale = (_props$locale = props.locale) !== null && _props$locale !== void 0 ? _props$locale : 'en';
  _luxon2.Settings.defaultZone = (0, _date.tz)(props.defaultTimeZone);
  _react.default.useEffect(() => {
    setTemporalValue(prev => {
      if (props.value !== prev && props.value) {
        return initializeDate(props.value, props.defaultTimeZone);
      } else {
        return prev;
      }
    });
  }, [props.defaultTimeZone, props.value]);
  _react.default.useEffect(() => {
    setMinDateTime(initializeDate(props.minDate, props.defaultTimeZone));
  }, [props.defaultTimeZone, props.minDate]);
  _react.default.useEffect(() => {
    setMaxDateTime(initializeDate(props.maxDate, props.defaultTimeZone));
  }, [props.defaultTimeZone, props.maxDate]);

  /**
   * Note: the inputProps override for placeholder is needed
   * with luxon since DatePicker's inputFormat as placeholder does not
   * work at least with MUI 5.x
   */
  const renderInput = params => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.TextField, Object.assign({}, params, {
    inputProps: {
      ...params.inputProps,
      placeholder: 'yyyy-mm-dd'
    },
    id: props.id,
    autoFocus: props.autoFocus,
    onKeyPress: props.onKeyPress
  })), props.errorText && /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield-error-text-container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "error",
    className: "textfield-error-text--icon"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.id,
    className: "textfield-error-text"
  }, props.errorText)));

  // TODO: Localize the yyyy-mm-dd placeholder string that is shown to users when the input is
  //       empty. It appears to be generated programmatically deep in the guts of the MUI DatePicker
  //       code, and it most likely uses the browser's locale.
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker ".concat(props.className, " ").concat(props.errorText ? 'date-picker--error' : '')
  }, /*#__PURE__*/_react.default.createElement(_xDatePickers.LocalizationProvider, {
    dateAdapter: _luxon.default,
    adapterLocale: locale
  }, props.label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.id,
    className: "textfield-label"
  }, props.label), /*#__PURE__*/_react.default.createElement(_xDatePickers.DesktopDatePicker, {
    disabled: props.disabled,
    inputFormat: "yyyy-MM-dd",
    minDate: minDateTime && minDateTime.isValid ? minDateTime : undefined,
    maxDate: maxDateTime && maxDateTime.isValid ? maxDateTime : undefined,
    onChange: newValue => {
      setTemporalValue(newValue);
      // TODO: remove onChange and make onDateChange required
      if (props.onChange) {
        props.onChange(newValue && newValue.isValid ? newValue.toJSDate() : null);
      }
      if (props.onDateChange) {
        props.onDateChange(newValue && newValue.isValid ? newValue : undefined);
      }
    },
    onError: props.onError,
    renderInput: renderInput,
    value: temporalValue
  })));
}